import styled from 'styled-components';
import { getColor } from '@karma/components/colors';

export const StyledSpan = styled.span`
  font-weight: 600;
  line-height: 1.5;
  color: ${getColor('primary1')};

  cursor: pointer;
`;
